import { useId } from 'react';

import type { WithChildren } from '@dynatrace/strato-components/core';

import { TimeseriesChartIdContext } from '../context/TimeseriesChartId.context.js';
import { useResetSelectionOnUnmount } from '../hooks/useResetSelectionOnUnmount.js';

export const TimeseriesChartIdProvider = ({ children }: WithChildren) => {
  const chartId = useId();
  useResetSelectionOnUnmount();

  return (
    <TimeseriesChartIdContext.Provider value={chartId}>
      {children}
    </TimeseriesChartIdContext.Provider>
  );
};
